/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForJiraServiceDeskIncidentManagement extends models.GovernanceConfigurationBaseForJiraServiceDesk {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForJiraServiceDeskIncidentManagement");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForJiraServiceDeskIncidentManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForJiraServiceDeskIncidentManagement>): GovernanceConfigurationForJiraServiceDeskIncidentManagement {
        let obj = Object.assign(new GovernanceConfigurationForJiraServiceDeskIncidentManagement(), model);
        GovernanceConfigurationForJiraServiceDeskIncidentManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForJiraServiceDeskIncidentManagement>): GovernanceConfigurationForJiraServiceDeskIncidentManagement {
        if (!model) return null;
        return GovernanceConfigurationForJiraServiceDeskIncidentManagement.newInstance(<GovernanceConfigurationForJiraServiceDeskIncidentManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForJiraServiceDeskIncidentManagement) {
        if (!obj) return;

        models.GovernanceConfigurationForJiraServiceDeskIncidentManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForJiraServiceDeskIncidentManagement): boolean {
        if (models.GovernanceConfigurationBaseForJiraServiceDesk.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForJiraServiceDeskIncidentManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.project) {
            models.JiraProject.fixupPrototype(this.project);
        }
    }

    project: models.JiraProject;

    /**
     * Summary of the Incident
     */
    summary: string;

    selected_description_attributes: Array<models.JiraServiceDeskIncidentDescriptionAttribute>;

    /**
     * Assignee of the Incident
     */
    assignee: string;

}
